import {useLang} from "../context/LanguageContext";
import BgImage from "../images/games_bg.png";
import DateUtils from "../utils/dateUtils";
import {useAuth} from "../context/AuthContext";
import {useNavigate} from "react-router-dom";


const Game = ({game}) => {
    const { t, getBetTranslation } = useLang();
    const { hasPaid } = useAuth();
    const navigate = useNavigate();

    const translatedMarketName = getBetTranslation(game.marketName);
    const translatedMarket = getBetTranslation(game.market);

    return (
        <div
            key={game.id}
            className="
                relative
                rounded
                shadow
                p-4
                border-r-2 border-[#27ae60]
                text-white
                bg-cover bg-center
                min-h-[120px]
              "
            style={{ backgroundImage: `url(${BgImage})` }}
        >
            <div className="flex items-center mb-2">
                {game.flag && (
                    <img
                        src={game.flag}
                        alt="Flag"
                        className="w-6 h-6 mr-2"
                    />
                )}
                <span className="font-bold text-sm">{game.countryName}</span>
            </div>

            <div className="flex items-center text-sm mb-2">
                <span className="mr-4">{DateUtils.formatDayOnly(game.day, t)}</span>
                <span>{game.hour}</span>
            </div>

            <div className="font-semibold text-sm mb-2">
                {game.team1} vs {game.team2}
            </div>

            <hr className="border-gray-300 mx-4 mb-2" />

            {hasPaid ? (
                <div className="flex flex-row justify-between">
                  <span className="text-sm">
                    {translatedMarketName} ({translatedMarket})
                  </span>
                    <span className="text-lg font-bold text-green-300">
                    {game.odd}
                  </span>
                </div>
            ) : (
                <button
                    onClick={() => navigate('/account')}
                    className="px-3 py-1 bg-blue-500 text-white rounded text-sm"
                >
                    {t('btn.unlockPremium')}
                </button>
            )}
        </div>
    );
}

export default Game;